import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from "react-redux";
import { Col, Card, CardBody, CardHeader, Row, Container, CardTitle } from "reactstrap";
import { connect } from 'react-redux';
import moment from 'moment'
import "moment/locale/es";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { collection, doc, onSnapshot, orderBy, query, where, getDocs, getDoc, limit, startAfter, startAt } from "firebase/firestore";
import { firestore } from "../../Firebase/firebaseConfig";
import {
  addLogins, setLogins
} from "../../store/data/actions";

const Sessions = (props) => {
  document.title = "TicketControl Monitor  | Sesiones";
  const dispatch = useDispatch();
  const { logins } = props;


  ///////////// LOGINS //// BUSCA TODOS LOS LOGINS HASTA 30 DIAS. REEMPLAZA LO EXISTENTE DE LISTENING
  useEffect(() => {

    if (!props.currentCompany?.id) {
      return;
    }

    // if (props.logins.length > 1) { // EVITA VOLVER A CARGAR SI YA HAY DATOS
    //   return
    // }

    const fetchData = async () => {
      const userId = props.currentCompany.id;
      const loginsRef = collection(doc(firestore, 'users', userId), 'logins');
      const fechaLimite = new Date();
      fechaLimite.setDate(fechaLimite.getDate() - 30);
      const q = query(loginsRef, where('created', '>', fechaLimite.toISOString()), orderBy('created', 'desc'));

      // Obtener documentos iniciales
      const initialQuerySnapshot = await getDocs(q);
      const initialDocuments = [];
      let last_doc = null;
      initialQuerySnapshot.forEach((doc) => {
        const docData = doc.data();
        if (last_doc == null) {
          last_doc = docData.created;
        }
        initialDocuments.push(docData);
      });

      dispatch(setLogins(initialDocuments));

    };

    fetchData();


  }, []);

  if (props.logins.length === 0) {
    return (
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="TicketControl" breadcrumbItem="Sesiones" />
          <div className="text-center text-muted py-5">
            <span className="material-symbols-rounded d-block mb-3" style={{ fontSize: 48, opacity: 0.3 }}>login</span>
            No hay sesiones registradas
          </div>
        </Container>
      </div>
    );
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="TicketControl" breadcrumbItem="Sesiones" />

          <div className="text-muted mb-3" style={{ fontSize: 13 }}>
            <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>login</span>
            Historial de inicios de sesión en TicketControl de los últimos 30 días. Cada registro muestra el operador y la fecha/hora en que accedió al sistema.
          </div>

          <Row>

            {logins.map((login, index) => {
              const currentDate = moment(login.created).format('YYYY-MM-DD');
              const isNewDate = index === 0 || currentDate !== moment(logins[index - 1].created).format('YYYY-MM-DD');

              return (
                <React.Fragment key={index}>
                  {isNewDate && (
                    <Col lg={12}>
                      <div className="d-flex align-items-center mb-2 mt-3">
                        <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>calendar_today</span>
                        <h5 className="text-primary m-0" style={{ fontWeight: 600 }}>
                          {moment(login.created).format('dddd DD/MM')}
                        </h5>
                      </div>
                    </Col>
                  )}

                  <Col xxl={3} xl={3} lg={4} md={4} sm={6} xs={12}>
                    <Card className="shadow-sm mb-3" style={{ borderLeft: "3px solid var(--bs-primary)", borderRadius: 8 }}>
                      <CardBody className="py-2 px-3">
                        <div className="d-flex align-items-center mb-1">
                          <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>person</span>
                          <span style={{ fontSize: 15, fontWeight: 600 }}>{login.fullName}</span>
                        </div>
                        <div className="text-muted" style={{ fontSize: 13 }}>
                          <span className="material-symbols-rounded me-1" style={{ fontSize: 14 }}>schedule</span>
                          {moment(login.created).format('DD/MM/YYYY HH:mm:ss')}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({

})

const mapStateToProps = (state) => ({
  logins: state.data.logins,
  currentCompany: state.companies.currentCompany
})

export default connect(mapStateToProps, mapDispatchToProps)(Sessions);